module.exports = __webpack_public_path__ + "img/clear.567aa4b9.svg";